import { create } from 'zustand';

type AppStore = {
  modifier: string | null;
  setModifier: (modifier: string | null) => void;
  formType: string | null;
  setFormType: (formType: string | null) => void;
  trialLength: number | null;
  setTrialLength: (trialLength: number | null) => void;
  trialType: string | null;
  setTrialType: (trialType: string | null) => void;
  isLoggedIn: boolean;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  isCompany: boolean;
  setIsCompany: (isCompany: boolean) => void;
  segExpQuery: string | null;
  setSegExpQuery: (segExpQuery: string | null) => void;
  segExpValue: string | null;
  setSegExpValue: (segExpValue: string | null) => void;
  contentId: string | null;
  setContentId: (contentId: string | null) => void;
  businessMax: boolean | null;
  setBusinessMax: (businessMax: boolean | null) => void;
  plus: boolean | null;
  setPlus: (plus: boolean | null) => void;
  app: boolean | null;
  setApp: (app: boolean | null) => void;
  isLPPlus: boolean;
  setIsLPPlus: (isLPPlus: boolean) => void;
  ctaButton: string | null;
  setCtaButton: (ctaButton: string | null) => void;
  ctaClassNameModifier: string | null;
  setCtaClassNameModifier: (ctaClassNameModifier: string | null) => void;
  emailPlaceholder: string | null;
  setEmailPlaceholder: (emailPlaceholder: string | null) => void;
};

export const useAppStore = create<AppStore>((set) => ({
  modifier: null,
  setModifier: (modifier) => set({ modifier }),
  formType: null,
  setFormType: (formType) => set({ formType }),
  trialLength: null,
  setTrialLength: (trialLength) => set({ trialLength }),
  trialType: null,
  setTrialType: (trialType) => set({ trialType }),
  isLoggedIn: false,
  setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
  isCompany: false,
  setIsCompany: (isCompany) => set({ isCompany }),
  segExpQuery: null,
  setSegExpQuery: (segExpQuery) => set({ segExpQuery }),
  segExpValue: null,
  setSegExpValue: (segExpValue) => set({ segExpValue }),
  contentId: null,
  setContentId: (contentId) => set({ contentId }),
  businessMax: null,
  setBusinessMax: (businessMax) => set({ businessMax }),
  plus: null,
  setPlus: (plus) => set({ plus }),
  app: null,
  setApp: (app) => set({ app }),
  isLPPlus: false,
  setIsLPPlus: (isLPPlus) => set({ isLPPlus }),
  ctaButton: null,
  setCtaButton: (ctaButton) => set({ ctaButton }),
  ctaClassNameModifier: null,
  setCtaClassNameModifier: (ctaClassNameModifier) => set({ ctaClassNameModifier }),
  emailPlaceholder: null,
  setEmailPlaceholder: (emailPlaceholder) => set({ emailPlaceholder }),
}));
